export const colors = {
    primaryDark: '#232421', // Dark color
    secondaryDark: '#241c14',
    primaryLight: '#c5c6c1', // Light color
    secondaryLight: '#d5c4b3',
    accent: '#5c3828', // Accent color
  };
  